import { ItemAvailabilityStatus } from 'enums/menu';
import { DAY_PART_SELECTIONS, IDayPartBoundary } from 'state/menu/main-menu/types';
import { ILocalizedMenuEntry, PosServiceMode } from 'state/unified-menu/types';

export const getOneMenuAvailability = (
  item: ILocalizedMenuEntry | undefined,
  activeDayParts: IDayPartBoundary[],
  posServiceMode: PosServiceMode,
  storeHasBurgersForBreakfast: boolean
): ItemAvailabilityStatus => {
  if (!item) {
    return ItemAvailabilityStatus.OUT_OF_MENU;
  }

  const isAvailableForActiveDayParts = activeDayParts?.some(({ key }) =>
    item.dayParts?.includes(key)
  );

  if (!isAvailableForActiveDayParts) {
    return ItemAvailabilityStatus.OUT_OF_DAYPART;
  }

  /**
   * null or true availability means it is available
   */
  const isAvailableInPos =
    !item.availability ||
    item.availability[posServiceMode] == null ||
    !!item.availability[posServiceMode];

  if (!isAvailableInPos) {
    return ItemAvailabilityStatus.UNAVAILABLE;
  }

  const isBurgerForBreakfast = item.dayParts?.includes(DAY_PART_SELECTIONS.BURGERS_FOR_BREAKFAST);

  if (isBurgerForBreakfast && !storeHasBurgersForBreakfast) {
    return ItemAvailabilityStatus.OUT_OF_DAYPART;
  }

  return ItemAvailabilityStatus.AVAILABLE;
};
